import { useForm } from "react-hook-form";
import { string, object } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect } from "react";
import { Box, Button, Modal } from "@mui/material";
import ReactTextInput from "../../../../components/ControllerComponent/ReactTextInput";
import clsx from "clsx";
import useMediaQuery from "../../../../base/useMediaQuery";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  width: "96%",
  bgcolor: "background.paper",
  borderRadius: 2,
  p: 3,
};

const validationSchema = object().shape({
  roleTitle: string().required("Role title is required*"),
});

const RoleTitleEditModal = ({ open = false, onClose, onSubmit, role }) => {
  const isDeskTop = useMediaQuery("(min-width: 400px)");

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: { roleTitle: "" },
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (open) setValue("roleTitle", role?.title);
    else clearErrors();
  }, [open]);

  const onSubmitData = useCallback(
    async (data) => {
      onSubmit({ data: data, roleId: role?.id });
    },
    [role]
  );

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <h1
          className={clsx(
            "flex items-center my-3 gap-2 text-[#00684E] font-['Poppins-Medium'] ",
            {
              "text-xl": isDeskTop,
              "text-[20px]": !isDeskTop,
            }
          )}
        >
          Edit Role Title
        </h1>
        <hr className="mb-4" />
        <ReactTextInput
          hookFormControl={control}
          label="Role Title"
          varName="roleTitle"
          errorMessage={errors.roleTitle?.message}
          maxLength={80}
          placeholder="Enter Role Title"
        />
        <Box
          sx={{ display: "flex", gap: 1, justifyContent: "flex-end", pt: 2 }}
        >
          <Button
            className="font-['Poppins-Medium'] normal-case text-[14px]"
            sx={{ color: "black" }}
            onClick={onClose?.bind(this)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(onSubmitData)}
            className="bg-[#00684E] font-['Poppins-Medium'] normal-case text-[14px] text-white"
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RoleTitleEditModal;
